/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssignmentRuleScope = {
    Facility: 'FACILITY',
    Source: 'SOURCE',
    Connector: 'CONNECTOR'
} as const;
export type AssignmentRuleScope = typeof AssignmentRuleScope[keyof typeof AssignmentRuleScope];


export function AssignmentRuleScopeFromJSON(json: any): AssignmentRuleScope {
    return AssignmentRuleScopeFromJSONTyped(json, false);
}

export function AssignmentRuleScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignmentRuleScope {
    return json as AssignmentRuleScope;
}

export function AssignmentRuleScopeToJSON(value?: AssignmentRuleScope | null): any {
    return value as any;
}

